<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update file</small>
      </legend>
      <div>
        <form @submit.prevent="fileopeningUpdate()">
          <div class="row">
            <div class="col-md-3">
              <input type="hidden" class="id" :value="Fileopening.id" />
              <input type="hidden" class="customer_id" :value="Fileopening.customer_id" />
              <input type="hidden" class="file_code" :value="Fileopening.file_code" />
              <div class="form-group">
                <label>File Code</label>
                <input
                  type="text"
                  class="form-control file_code input-rounded f-s-14"
                  placeholder="file code"
                  :value="Fileopening.file_code"
                  required
                  readonly
                />
              </div>

              <div class="form-group">
                <label>
                  Movement
                  <span class="text-danger">*</span>
                </label>
                <select
                  name="file_mov"
                  class="form-control file_mov input-rounded f-s-14"
                  :value="Fileopening.file_mov"
                >
                  <option value>Select movement</option>
                  <option value="IMPORT">IMPORT</option>
                  <option value="EXPORT">EXPORT</option>
                  <option value="TRANSPORT">TRANSPORT</option>
                </select>
              </div>

              <div class="form-group">
                <label>
                  Cargo status
                  <span class="text-danger">*</span>
                </label>
                <select
                  name="cargo_status"
                  class="form-control cargo_status input-rounded f-s-14"
                  :value="Fileopening.cargo_status"
                >
                  <option value>Select cargo status</option>
                  <option value="DRY">DRY</option>
                  <option value="REEFER">REEFER</option>
                  <option value="DANGEROUS">DANGEROUS</option>
                </select>
              </div>

              <div class="form-group">
                <label>
                  Eta
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control eta input-rounded f-s-14"
                  placeholder="expected time arrival"
                  :value="Fileopening.eta"
                  required
                />
              </div>

              <div class="form-group">
                <label>
                  Remarks
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control remarks input-rounded f-s-14"
                  placeholder="file remarks"
                  :value="Fileopening.remarks"
                  required
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>
                  Received date
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control received_date input-rounded f-s-14"
                  placeholder="file received date"
                  :value="Fileopening.received_date"
                  required
                />
              </div>

              <div class="form-group">
                <label>
                  Shipping line
                  <span class="text-danger">*</span>
                </label>
                <select
                  class="form-control shipping_id input-rounded f-s-14"
                  required
                  :value="Fileopening.shipping_id"
                >
                  <option value>Select Shipping line</option>
                  <option
                    v-for="shipping in systemShippinglines"
                    :value="shipping.id"
                    :key="shipping.id"
                  >{{ shipping.shipping_name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label>
                  Clearing agent
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control clearing_agent input-rounded f-s-14"
                  placeholder="clearing agent"
                  :value="Fileopening.clearing_agent"
                  required
                />
              </div>

              <div class="form-group">
                <label>
                  Description
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control description input-rounded f-s-14"
                  placeholder="goods descriptions"
                  :value="Fileopening.description"
                  required
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>
                  Opened date
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control opened_date input-rounded f-s-14"
                  placeholder="opened date"
                  :value="Fileopening.opened_date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Origin</label>
                <input
                  type="text"
                  class="form-control origin input-rounded f-s-14"
                  placeholder="origin of the cargo"
                  :value="Fileopening.origin"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Discharge port
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control discharge_port input-rounded f-s-14"
                  placeholder="discharge port"
                  :value="Fileopening.discharge_port"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Cargo quantity
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control cargo_qty input-rounded f-s-14"
                  placeholder="cargo quantity"
                  :value="Fileopening.cargo_qty"
                  required
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>
                  Bill of landing
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control bill_landing input-rounded f-s-14"
                  placeholder="bill of landing"
                  :value="Fileopening.bill_landing"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Route
                  <span class="text-danger">*</span>
                </label>
                <select
                  name="file_mov"
                  class="form-control file_route input-rounded f-s-14"
                  :value="Fileopening.file_route"
                >
                  <option value>Select route</option>
                  <option value="TRANSIT">TRANSIT</option>
                  <option value="LOCAL">LOCAL</option>
                  <option value="TRANSPORT">TRANSPORT</option>
                  <option value="SEA EXPORT">SEA EXPORT</option>
                  <option value="AIR IMPORT">AIR IMPORT</option>
                  <option value="AIR EXPORT">AIR EXPORT</option>
                </select>
              </div>
              <div class="form-group">
                <label>
                  Destination
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control destination input-rounded f-s-14"
                  placeholder="destination of cargo"
                  :value="Fileopening.destination"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Vessel
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control vessel input-rounded f-s-14"
                  placeholder="vessel"
                  required
                  :value="Fileopening.vessel"
                />
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary btn-flat updatingFileopening btn-rounded">
            <i class="fa fa-file"></i> update file
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat updatingFileopeningLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Fileopening.length === 0) {
      router.push("/managefileopenings");
    }
    this.loadShippinglines();
  },
  computed: {
    ...mapGetters(["Fileopening", "systemShippinglines"])
  },
  methods: {
    ...mapActions(["fileopeningUpdate", "loadShippinglines"])
  }
};
</script>
<style scoped>
.updatingFileopeningLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/fileopenings/updatefileopening.vue